import i18n from '@/shared/i18n';
import AuthMessage from '@/shared/components/ui/molecules/AuthMessage';

/**
 * Error state molecule for CreatePasswordPage.
 *
 * Shown when invitation registration fails or when the onboarding
 * link is invalid/expired.
 *
 * @category Molecules
 */
export const CreatePasswordError = () => (
  <div className="auth-page-container">
    <div className="auth-container">
      <AuthMessage
        subtitle={i18n.t('Identity and Fraud Platform')}
        title={i18n.t('Make a new request')}
        description={i18n.t(
          'Attention! There was an error in your validation process.'
        )}
        alert={{
          message: i18n.t(
            'No access! Ask your requester to resend a new registration link.'
          ),
          type: 'error',
        }}
      />
    </div>
  </div>
);
